module.exports = __webpack_public_path__ + "static/meningitis-a-27d1f1c56f3fec9db52c7fcd8d030f2a.png";